<template>
  <div id="pdfDom" style="font-size: 23px; color: #000; font-family: '宋体'">
    <table border="1" cellpadding="15" cellspacing="0" style="width: 100%">
      <tr align="center">
        <th colspan="5" style="font-size: 40px">无人环卫车辆/装备交接表</th>
      </tr>
      <tr>
        <th colspan="5" style="font-size: 30px">交接基本信息</th>
      </tr>
      <tr>
        <td>交付方</td>
        <td>{{ editForm["交付方"] }}</td>
        <td>接收方</td>
        <td colspan="2">{{ editForm["接收方"] }}</td>
      </tr>
      <tr>
        <td>交付联系人</td>
        <td>{{ editForm["交付联系人"] }}</td>
        <td>接收联系人</td>
        <td colspan="2">{{ editForm["接收联系人"] }}</td>
      </tr>
      <tr>
        <td>联系方式</td>
        <td>{{ editForm["交付方联系方式"] }}</td>
        <td>联系方式</td>
        <td colspan="2">{{ editForm["接收方联系方式"] }}</td>
      </tr>
      <tr>
        <th colspan="5" style="font-size: 30px">项目确认</th>
      </tr>
      <tr>
        <td style="width: 20%">车辆/装备型号</td>
        <td style="width: 30%">{{ editForm.carType }}</td>
        <td style="width: 15%">识别编码</td>
        <td colspan="2">{{ editForm.vin }}</td>
      </tr>
      <tr>
        <th colspan="2" style="font-size: 30px">静态检验（请填写√或？）</th>
        <th colspan="3" style="font-size: 30px">功能查验（请填写√或？）</th>
      </tr>
      <tr>
        <td>整体漆面完整无变色</td>
        <td align="center">{{ editForm["项目确认"]["静态检验"][0].tag }}</td>
        <td rowspan="3">遥控驾驶</td>
        <td style="width: 120px">速度</td>
        <td align="center">{{ editForm["项目确认"]["遥控驾驶"][0].tag }}</td>
      </tr>
      <tr>
        <td>外观套件无破损变形</td>
        <td align="center">{{ editForm["项目确认"]["静态检验"][1].tag }}</td>
        <td>转向</td>
        <td align="center">{{ editForm["项目确认"]["遥控驾驶"][1].tag }}</td>
      </tr>
      <tr>
        <td>设备完整无漏装或损坏</td>
        <td align="center">{{ editForm["项目确认"]["静态检验"][2].tag }}</td>
        <td>急停</td>
        <td align="center">{{ editForm["项目确认"]["遥控驾驶"][2].tag }}</td>
      </tr>
      <tr>
        <td>遥控器等配件完备</td>
        <td align="center">{{ editForm["项目确认"]["静态检验"][3].tag }}</td>
        <td rowspan="3">自动驾驶</td>
        <td>巡航</td>
        <td align="center">{{ editForm["项目确认"]["自动驾驶"][0].tag }}</td>
      </tr>
      <tr>
        <th colspan="2" align="center" style="font-size: 30px">
          其他查验（请填写√或？）
        </th>
        <td>避障</td>
        <td align="center">{{ editForm["项目确认"]["自动驾驶"][1].tag }}</td>
      </tr>
      <tr>
        <td rowspan="7" colspan="2" class="aaa" style="border-style: none">
          <table
            border="1"
            cellpadding="15"
            cellspacing="0"
            style="width: 100%; border-style: none"
          >
            <tr style="" v-for="(item, index) in shuzu1" :key="index">
              <td style="width: 40%">
                {{
                  typeof editForm["项目确认"]["其他查验"][item] == "undefined"
                    ? ""
                    : editForm["项目确认"]["其他查验"][item].city
                }}
              </td>
              <td align="center" style="height: 26px">
                {{
                  typeof editForm["项目确认"]["其他查验"][item] == "undefined"
                    ? ""
                    : editForm["项目确认"]["其他查验"][item].tag
                }}
              </td>
            </tr>
          </table>
        </td>

        <td>制动</td>
        <td align="center">{{ editForm["项目确认"]["自动驾驶"][2].tag }}</td>
      </tr>
      <tr>
        <td rowspan="3" style="height: 120px">作业功能</td>
        <td>清扫</td>
        <td align="center">{{ editForm["项目确认"]["作业功能"][0].tag }}</td>
      </tr>
      <tr>
        <td>喷水</td>
        <td align="center">{{ editForm["项目确认"]["作业功能"][1].tag }}</td>
      </tr>
      <tr>
        <td>吸储</td>
        <td align="center">{{ editForm["项目确认"]["作业功能"][2].tag }}</td>
      </tr>
      <tr>
        <td rowspan="3">软件功能</td>
        <td rowspan="3" colspan="2" class="aaa" style="border-style: none">
          <table
            border="1"
            cellpadding="15"
            cellspacing="0"
            style="width: 100%; border-style: none"
          >
            <tr style="" v-for="(item, index) in shuzu2" :key="index">
              <td style="width: 33%">
                {{
                  typeof editForm["项目确认"]["软件功能"][item] == "undefined"
                    ? ""
                    : editForm["项目确认"]["软件功能"][item].city
                }}
              </td>
              <td align="center" style="height: 26px">
                {{
                  typeof editForm["项目确认"]["软件功能"][item] == "undefined"
                    ? ""
                    : editForm["项目确认"]["软件功能"][item].tag
                }}
              </td>
            </tr>
          </table>
        </td>
      </tr>
      <tr></tr>
      <tr></tr>
      <tr>
        <th colspan="5" style="font-size: 30px">资料/配件交接</th>
      </tr>
      <tr>
        <td colspan="5" style="height: 120px">
          <div>
            <div
              style="
                height: 15px;
                width: 15px;
                border: 1px black solid;
                float: left;
                margin-top: 5px;
                margin-right: 15px;
              "
            ></div>
            <div style="float: left; margin-top: -5px">
              <div
                style="float: left; margin-left: -38px; font-size: 30px"
                v-if="
                  editForm['项目确认']['配件交接'][0].tag == '√' ? true : false
                "
              >
                {{ editForm["项目确认"]["配件交接"][0].tag }}
              </div>
            </div>
            <div style="font-size: 20px">
              {{ editForm["项目确认"]["配件交接"][0].city }}
            </div>
          </div>
          <div>
            <div
              style="
                height: 15px;
                width: 15px;
                border: 1px black solid;
                float: left;
                margin-top: 5px;
                margin-right: 15px;
              "
            ></div>
            <div style="float: left; margin-top: -5px">
              <div
                style="float: left; margin-left: -38px; font-size: 30px"
                v-if="
                  editForm['项目确认']['配件交接'][1].tag == '√' ? true : false
                "
              >
                {{ editForm["项目确认"]["配件交接"][1].tag }}
              </div>
            </div>
            <div style="font-size: 20px">
              {{ editForm["项目确认"]["配件交接"][1].city }}
            </div>
          </div>
          <div>
            <div
              style="
                height: 15px;
                width: 15px;
                border: 1px black solid;
                float: left;
                margin-top: 5px;
                margin-right: 15px;
              "
            ></div>
            <div style="float: left; margin-top: -5px">
              <div
                style="float: left; margin-left: -38px; font-size: 30px"
                v-if="
                  editForm['项目确认']['配件交接'][2].tag == '√' ? true : false
                "
              >
                {{ editForm["项目确认"]["配件交接"][2].tag }}
              </div>
            </div>
            <div style="font-size: 20px">
              {{ editForm["项目确认"]["配件交接"][2].city }}
            </div>
          </div>
          <div>
            <div
              style="
                height: 15px;
                width: 15px;
                border: 1px black solid;
                float: left;
                margin-top: 5px;
                margin-right: 15px;
              "
            ></div>
            <div style="float: left; margin-top: -5px">
              <div
                style="float: left; margin-left: -38px; font-size: 30px"
                v-if="
                  editForm['项目确认']['配件交接'][3].tag == '√' ? true : false
                "
              >
                {{ editForm["项目确认"]["配件交接"][3].tag }}
              </div>
            </div>
            <div style="font-size: 20px">
              {{ editForm["项目确认"]["配件交接"][3].city }}
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <th colspan="5" style="font-size: 30px">交接存在问题</th>
      </tr>
      <tr>
        <td colspan="2" align="center" style="height: 20px">问题描述</td>
        <td align="center" style="height: 20px">整改期限</td>
        <td colspan="2" align="center" style="height: 20px">整改措施</td>
      </tr>
      <tr v-for="(item, index) in shuzu" :key="index">
        <td colspan="2" align="center" style="height: 20px">
          {{
            typeof editForm["交接存在问题"][item] == "undefined"
              ? ""
              : editForm["交接存在问题"][item]["问题描述"]
          }}
        </td>
        <td align="center" style="height: 20px">
          {{
            typeof editForm["交接存在问题"][item] == "undefined"
              ? ""
              : editForm["交接存在问题"][item]["整改期限"]
          }}
        </td>
        <td colspan="2" align="center" style="height: 20px">
          {{
            typeof editForm["交接存在问题"][item] == "undefined"
              ? ""
              : editForm["交接存在问题"][item]["整改措施"]
          }}
        </td>
      </tr>
      <tr>
        <th colspan="5" align="center" style="font-size: 30px">双方签字确认</th>
      </tr>
      <tr>
        <td align="right" colspan="5" style="height: 100px">
          <p style="margin-top: 100px; margin-right: 50px; font-size: 18px">
            年&nbsp;&nbsp;月&nbsp;&nbsp;日
          </p>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    editForm: Object,
  },
  data() {
    return {
      shuzu: [0, 1, 2, 3, 4],
      shuzu1: [0, 1, 2, 3, 4, 5, 6],
      shuzu2: [0, 1, 2],
    };
  },
};
</script>

<style>
.aaa {
  padding: 0 !important;
}
</style>


// WEBPACK FOOTER //
// src/views/pdf.vue